import React from 'react'
import { object, string, array } from 'prop-types'

class ParkingInformation extends React.Component {
  render () {
    const { productData = {}, id, functionParams } = this.props
    const productName = (functionParams[1] || productData._base_name || productData.name).replace(/\b\w/g, l => l.toUpperCase())

    if (!productData) {
      return (
        <h2>No data found for { productName }</h2>
      )
    }

    return (
      <div id={id}>

        { productData.tripappintroduction && (
          <div>
            <p dangerouslySetInnerHTML={{ __html: productData.tripappintroduction }} />
          </div>
        )}

        { productData.tripappcarparkstory && (
          <div>
            <h2>Getting to and from { productData._airport_info.name } airport</h2>
            <p dangerouslySetInnerHTML={{ __html: productData.tripappcarparkstory }} />
          </div>
        )}

        { !productData.meet_and_greet && (
          <div className='direction-details vcard' id='direction-details'>
            { productData.address && productData.postcode && (
              <div itemScope itemType='http://schema.org/LocalBusiness'>
                <h2><span itemProp='name' className='fn'>{ productName }</span> Address</h2>
                <div itemProp='address' itemScope itemType='http://schema.org/PostalAddress'>
                  <p>
                    <span className='adr' dangerouslySetInnerHTML={{ __html: productData.address.replace(productData.postcode, '') }} />
                    <span itemProp='postalCode' dangerouslySetInnerHTML={{ __html: productData.postcode }} />
                  </p>
                </div>
              </div>
            )}
            { productData.address && !productData.postcode && (
              <div>
                <h2>{ productName } Address</h2>
                <p dangerouslySetInnerHTML={{ __html: productData.address }} />
              </div>
            )}
            { productData.latitude && productData.longitude && (
              <p>
                <span className='geo'>
                  <strong>Longitude</strong> <span className='longitude'>{ productData.longitude.toString().substr(0, 8) }</span><br />
                  <strong>Latitude</strong> &nbsp; &nbsp;<span className='latitude'>{ productData.latitude.toString().substr(0, 8) }</span>
                </span>
              </p>
            )}
          </div>
        )}
        { productData.prices && productData.prices.startDate && (
          <p><small>* Prices quoted are based on parking from the { productData.prices.startDate } untill the { productData.prices.endDate }, valid as of { productData.prices.dateUsed }</small></p>
        )}
      </div>
    )
  }
}

ParkingInformation.propTypes = {
  productData: object,
  functionParams: array,
  id: string
}

ParkingInformation.defaultProps = {
  productData: { }
}

export default ParkingInformation



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/specificProduct/parkingInformation.jsx